import { render } from "./CoachSection.vue?vue&type=template&id=7ae5f397&scoped=true"
const script = {}

import "./CoachSection.vue?vue&type=style&index=0&id=7ae5f397&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guifernandespro\\development\\projects\\vue_icon-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae5f397"]])

export default __exports__